import * as React from "react";
import { useState } from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { importProjectBudgetFromExcel } from "../../../../services/api/ProjectBudget/ProjectBudgetService";
import { IApiResponse } from "../../../../@types/api-response.type";
import { toast } from "react-toastify";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

interface InputFileUploadProps {
  projectId: string;
  userId: string;
  setIsImported: (uploaded: boolean) => void;
}

export default function InputFileUpload({
  projectId,
  userId,
  setIsImported
}: InputFileUploadProps) {
  const [loading, setLoading] = useState<boolean>(false);

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (file) {
      const formData = new FormData();
      formData.append("file", file);

      try {
        setLoading(true);
        const response = (await importProjectBudgetFromExcel(
          projectId,
          userId,
          formData
        )) as IApiResponse<any>;

        if (response.statusCode === 200) {
          setIsImported(true);
          toast.success("Arquivo importado com sucesso!");
        } else {
          toast.error("Erro ao importar o arquivo. Tente novamente.");
        }
      } catch (error) {
        toast.error("Erro ao importar o arquivo. Tente novamente.");
        console.log("Erro ao importar arquivo:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Button
      sx={{
        textTransform: "none",
        fontWeight: 700,
        fontSize: "1rem",
        padding: "0.625rem 1.125rem",
        lineHeight: 0,
        height: "42px",
        marginTop: "2rem",
      }}
      loading={loading}
      component="label"
      role={undefined}
      variant="contained"
      tabIndex={-1}
      startIcon={<CloudUploadIcon />}
    >
      Importar Precificação
      <VisuallyHiddenInput
        type="file"
        accept=".xlsx, .xls, .csv, .text/csv, application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        onChange={handleFileChange}
      />
    </Button>
  );
}
